import type { DriverDraft } from './DriversDatabaseTable.types';

export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50];

export const MAX_LENGTHS: Record<keyof DriverDraft, number> = {
  driver: 40,
  identifier: 40,
  phone: 20,
};

export const EMPTY_DRAFT: DriverDraft = {
  driver: '',
  identifier: '',
  phone: '',
};

export const EMPTY_ERRORS: Record<keyof DriverDraft, boolean> = {
  driver: false,
  identifier: false,
  phone: false,
};

export const isInvalid = (field: keyof DriverDraft, value: string) =>
  !value.trim() || value.length > MAX_LENGTHS[field];
